export enum SpinnerColor {
  White = `white`,
  Blue = `blue`,
}

export enum SpinnerSize {
  Large = `large`,
  Small = `small`,
}

export enum SpinnerTheme {
  Default = `default`,
  Fancy = `fancy`,
}
